<template>
  <el-drawer class="user-detail" :visible.sync="drawerVisible" :show-close="false" size="70%" @close="handleBack">
    <ts-detail-tab :btn-list="btnList" :tab-info="tabInfo" :header-info="headerInfo" :is-open="drawerVisible" />
  </el-drawer>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import TsDetailTab from '@/components/TsDetailTab/index'
@Component({
  name: 'detailDrawer',
  components: {
    TsDetailTab
  }
})
export default class extends Vue {
  @Prop({ default: false }) value;
  @Prop({ default: Object }) headerInfo;
  @Prop({ default: Object }) searchFormData;
  editStatus = false;
  btnList = [
    {
      btnName: '返回',
      btnFuc: this.handleBack
    }
  ]

  tabInfo = {
    activeName: 'ActivationMsg',
    options: [
      {
        label: '许可证信息',
        name: 'ActivationMsg',
        active: 'ActivationMsg',
        dataObj: {}
      }
    ]
  }

  drawerVisible = false;
  @Watch('value')
  onValueChanged (newVal) {
    if (newVal) {
      this.tabInfo.options[0].dataObj = {
        list: [
          {
            label: '许可证信息',
            list: [
              {
                key: '许可证编号',
                value: this.searchFormData.id
              },
              {
                key: '创建时间',
                value: this.searchFormData.createTime ? this.searchFormData.createTime.slice(0, 10) : ''
              },
              {
                key: '使用费',
                value: this.searchFormData.royalty
              },
              {
                key: '服务费',
                value: this.searchFormData.technicalCost
              },
              {
                key: '咨询费',
                value: this.searchFormData.consultingFees
              },
              {
                key: '许可证权限',
                newLine: true,
                value: this.searchFormData.authorityList
              }
            ]
          },
          {
            label: '绑定用户',
            list: [
              {
                key: '用户姓名',
                value: this.searchFormData.username
              },
              {
                key: '实付金额',
                value: this.searchFormData.totalRoyalty
              }
            ]
          }
        ]
      }
    }
    this.drawerVisible = newVal
  }

  handleBack () {
    this.drawerVisible = false
    this.$emit('input', false)
  }
}
</script>

<style lang="scss">
.user-detail {
  .el-drawer__header {
    margin: 0;
  }
}
</style>
